import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import * as z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { AuthRedirectProvider } from "@/features/auth/_providers/auth-redirect-provider";
import { ResetPasswordSuccess } from "@/features/auth/reset-password-success";

export const Route = createFileRoute("/(auth)/reset-password-success")({
  validateSearch: z.object({
    identifier: z.string().optional(),
  }),
  component: ResetPasswordSuccessPage,
});

function ResetPasswordSuccessPage() {
  return (
    <AuthRedirectProvider>
      <PublicLayout>
        <ResponsiveWrapper
          className={cn(
            /* sorted */
            "grow",
            "py-12",
            "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
          )}
        >
          <ResetPasswordSuccess />
        </ResponsiveWrapper>
      </PublicLayout>
    </AuthRedirectProvider>
  );
}
